import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgApplicationStarted = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.73405 1.513V4.26669C9.73405 4.64006 9.73405 4.82675 9.80671 4.96935C9.87063 5.0948 9.97261 5.19678 10.0981 5.2607C10.2407 5.33336 10.4273 5.33336 10.8007 5.33336H13.5544M11.0674 8.66665H5.73405M11.0674 11.3333H5.73405M7.06738 5.99998H5.73405M9.73405 1.33331H6.26738C5.14728 1.33331 4.58723 1.33331 4.1594 1.5513C3.78308 1.74305 3.47712 2.04901 3.28537 2.42533C3.06738 2.85316 3.06738 3.41321 3.06738 4.53331V11.4666C3.06738 12.5868 3.06738 13.1468 3.28537 13.5746C3.47712 13.951 3.78308 14.2569 4.1594 14.4487C4.58723 14.6666 5.14728 14.6666 6.26738 14.6666H10.534C11.6542 14.6666 12.2142 14.6666 12.642 14.4487C13.0184 14.2569 13.3243 13.951 13.5161 13.5746C13.734 13.1468 13.734 12.5868 13.734 11.4666V5.33331L9.73405 1.33331Z",
		stroke: "#0064FA",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgApplicationStarted;
